<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>

    <horizontal-navbar @search="searchInstitutions" :searchedItems="searchedItems"></horizontal-navbar>

    <breadcrumb-slot :items="items" :modal="false"></breadcrumb-slot>

    <div class="p-1 d-flex justify-content-between">
      <h2 class="text-dark">TB დაწესებულება</h2>

      <b-button v-if="false" variant="primary" class="mb-3" @click="addModal(null)">
        <feather-icon icon="PlusCircleIcon"
                      class="mr-50"/>
        <span class="align-middle">რეგიონის დამატება</span>
      </b-button>
    </div>

    <div v-if="pageVisible">
      <template v-for="region in regions_detailed">
        <table-basic-institutions
            v-bind:key="region.id"
            @edit="editModal"
            @delete="deleteModal"
            @add="addModal"
            :rows="region.institutions"
            :title="region.title"
            :columns="columns">
        </table-basic-institutions>
      </template>
    </div>

    <b-modal id="modal-add-region"
             ref="region-modal"
             size="lg"
             class="p-3"
             hide-header
             hide-footer
             centered>

      <div class="modal-custom-header d-flex align-items-center justify-content-between">
        <h4>{{ editing === null ? title.region.add : title.region.edit }}</h4>

        <b-button variant="flat-secondary" class="btn-icon mr-1" size="lg" @click="hideModal">
          <feather-icon icon="XIcon"/>
        </b-button>
      </div>

      <b-form class="edit-institution d-flex row justify-content-between">
        <b-form-group label="რეგიონის სახელი *"
                      label-for="nameGe">
          <b-form-input id="nameGe" v-model="nameGe"
                        placeholder="რეგიონის სახელი"/>
        </b-form-group>
        <b-form-group label="რეგიონის სახელი ინგლისურად *"
                      label-for="nameEng">
          <b-form-input id="nameEng" v-model="nameEng"
                        placeholder="რეგიონის სახელი ინგლისურად"/>
        </b-form-group>
      </b-form>

      <div class="mt-3 d-flex justify-content-between align-items-center">

        <b-button v-if="editing === null" variant="primary" class="save-changes mb-3" @click="addRegion">
          <feather-icon icon="SaveIcon"
                        class="mr-50"/>
          <span class="align-middle">{{ title.region.add }}</span>
        </b-button>

        <b-button v-else variant="primary" class="save-changes mb-3" @click="updateRegion">
          <feather-icon icon="SaveIcon"
                        class="mr-50"/>
          <span class="align-middle">{{ title.region.edit }}</span>
        </b-button>

      </div>
    </b-modal>

    <b-modal id="modal-add-institution"
             ref="institution-modal"
             size="lg"
             class="p-3"
             hide-header
             hide-footer
             centered>

      <div class="modal-custom-header d-flex align-items-center justify-content-between">
        <h4>{{ editing === null ? title.institution.add : title.institution.edit }}</h4>

        <b-button variant="flat-secondary" class="btn-icon mr-1" size="lg" @click="hideModal">
          <feather-icon icon="XIcon"/>
        </b-button>
      </div>

      <b-form class="edit-institution d-flex row justify-content-between">
        <b-form-group label="დაწესებულების სახელი *"
                      label-for="nameGe">
          <b-form-input id="nameGeInstitution" v-model="nameGe"
                        placeholder="დაწესებულების სახელი"/>
        </b-form-group>
        <b-form-group label="დაწესებულების სახელი ინგლისურად *"
                      label-for="nameEng">
          <b-form-input id="nameEngInstitution" v-model="nameEng"
                        placeholder="დაწესებულების სახელი ინგლისურად"/>
        </b-form-group>
        <b-form-group label="დაწესებულების მისამართი *"
                      label-for="nameGe">
          <b-form-input id="addressGeInstitution" v-model="addressGe"
                        placeholder="დაწესებულების მისამართი"/>
        </b-form-group>
        <b-form-group label="დაწესებულების მისამართი ინგლისურად *"
                      label-for="nameEng">
          <b-form-input id="addressEngInstitution" v-model="addressEng"
                        placeholder="დაწესებულების მისამართი ინგლისურად"/>
        </b-form-group>
      </b-form>

      <div class="mt-3 d-flex justify-content-between align-items-center">

        <b-button v-if="editing === null" variant="primary" class="save-changes mb-3" @click="addInstitution">
          <feather-icon icon="SaveIcon"
                        class="mr-50"/>
          <span class="align-middle">{{ title.institution.add }}</span>
        </b-button>

        <b-button v-else variant="primary" class="save-changes mb-3" @click="updateInstitution">
          <feather-icon icon="SaveIcon"
                        class="mr-50"/>
          <span class="align-middle">{{ title.institution.edit }}</span>
        </b-button>

      </div>
    </b-modal>

  </div>
</template>

<script>

import BreadcrumbSlot from "../components/breadcrumb/BreadcrumbSlot";
import {
  BButton,
  BFormGroup,
  BFormInput,
  BForm,
  BModal,
} from "bootstrap-vue"
import TableBasicInstitutions from "../table/bs-table/TableBasicInstitutions";
import moduleRegions from "../../store/regions/moduleRegions"
import moduleInstitutions from "../../store/institution/moduleInstitution"
import HorizontalNavbar from "../navbar/HorizontalNavbar";

export default {
  components: {
    HorizontalNavbar,
    TableBasicInstitutions,
    BreadcrumbSlot,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    BModal,
  },
  data() {
    return {
      data: {},
      items: [
        {
          text: "TB დაწესებულება",
          active: true
        }
      ],
      columns: [
        {
          key: "institution",
          label: "დაწესებულება",
          sortable: true
        },
        {
          key: "accounts",
          label: "მომხმარებლები",
          sortable: true
        },
        {
          key: "indexes",
          label: "ინდექსები",
          sortable: true,
        },
        {
          key: "contacts",
          label: "კონტაქტები",
          sortable: true,
        },
        {
          key: "riskGroups",
          label: "რისკ-ჯგუფები",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
        },
      ],
      title: {
        institution: {
          edit: "დაწესებულების რედაქტირება",
          add: "დაწესებულების დამატება"
        },

        region: {
          edit: "რეგიონის რედაქტირება",
          add: "რეგიონის დამატება"
        }

      },
      editing: null,
      nameGe: "",
      nameEng: "",
      addressGe: "",
      addressEng: "",
      regionId: "",
      searchedItems: [],
      pageVisible: false,
      regions_detailed: []
    }
  },

  mounted() {
    if (!moduleRegions.isRegistered) {
      this.$store.registerModule("regions", moduleRegions);
      moduleRegions.isRegistered = true
    }
    if (!moduleInstitutions.isRegistered) {
      this.$store.registerModule("institution", moduleInstitutions);
      moduleInstitutions.isRegistered = true
    }
    this.getRegionsDetailed().then(() => {
      const appLoading = document.getElementById("loading-bg")
      if (appLoading) {
        appLoading.style.display = "none"
      }
    });

  },
  computed: {
    regions_detailed1() {
      return this.$store.state.regions.regions_detailed
    },
    region_translations() {
      return this.$store.state.regions.region_translations
    },
    institution_translations() {
      return this.$store.state.institution.institution_translations
    },
  },

  watch: {
    searchedItems: function (val) {
      console.log("searched items", this.searchedItems, val)
      if (val.length > 3) {this.getRegionsDetailed({searchWord: val});}
    }
  },

  methods: {

    searchInstitutions(newVal) {
      this.getRegionsDetailed({searchWord: newVal});
    },

    getRegionsDetailed(payload) {
      this.pageVisible = false;
      return this.$store.dispatch("regions/getRegionsDetailed", payload).then(() => {
        this.regions_detailed = this.$store.state.regions.regions_detailed;
        this.pageVisible = true
      }).catch((err) => {
      });
    },

    deleteRegion(id) {
      this.$store.dispatch("regions/deleteRegion", id).then(() => {
        this.getRegionsDetailed();
      }).catch((err) => {
      });
    },

    deleteInstitution(id) {
      this.$store.dispatch("institution/deleteInstitution", id).then(() => {
        this.getRegionsDetailed();
      }).catch((err) => {
      });
    },

    getRegionTranslations(id) {
      return this.$store.dispatch("regions/getRegionTranslations", id).then(() => {
      }).catch((err) => {
      });
    },

    getInstitutionTranslations(id) {
      return this.$store.dispatch("institution/getInstitutionTranslations", id).then((response) => {
        this.editing = response;
      }).catch((err) => {
      });
    },

    addModal(regionId = null) {
      this.regionId = regionId;
      this.editing = null;
      if (regionId !== null) {this.$refs["institution-modal"].show();}
      else {this.$refs["region-modal"].show();}
    },

    addRegion() {
      let payload = {
        "translations": [
          {
            "languageCode": "en",
            "title": this.nameEng,
          },
          {
            "languageCode": "ka",
            "title": this.nameGe,
          }
        ]
      };
      this.$store.dispatch("regions/addRegion", payload).then(() => {
        this.getRegionsDetailed();
        this.toast("რეგიონი");
        this.hideModal();
      }).catch((err) => {
      });
    },

    addInstitution() {
      let payload = {
        regionId: this.regionId,
        "translations": [
          {
            "languageCode": "en",
            "title": this.nameEng,
            "address": this.addressEng,
          },
          {
            "languageCode": "ka",
            "title": this.nameGe,
            "address": this.addressGe,
          }
        ]
      };
      this.$store.dispatch("institution/addInstitution", payload).then(() => {
        this.getRegionsDetailed();
        this.hideModal();
        this.toast("დაწესებულება");
      }).catch((err) => {
      });
    },

    updateRegion() {
      let payload = {
        "id": this.editing.id,
        "translations": [
          {
            "languageCode": "en",
            "title": this.nameEng,
            "address": this.addressGe,
          },
          {
            "languageCode": "ka",
            "title": this.nameGe,
            "address": this.addressGe,
          }
        ]
      };
      this.$store.dispatch("regions/updateRegion", payload).then(() => {
        this.getRegionsDetailed();
        this.hideModal();
      }).catch((err) => {
      });
    },

    updateInstitution() {
      let payload = {
        "id": this.editing.id,
        "translations": [
          {
            "languageCode": "en",
            "title": this.nameEng,
            "address": this.addressEng,
          },
          {
            "languageCode": "ka",
            "title": this.nameGe,
            "address": this.addressGe,
          }
        ]
      };
      this.$store.dispatch("institution/updateInstitution", payload).then(() => {
        this.getRegionsDetailed();
        this.hideModal();
      }).catch((err) => {
      });
    },

    editModal(item) {
      if (item.isRegion) {
        this.editRegion(item.id);
      } else {
        this.editInstitution(item.id);
      }
    },

    editRegion(id) {
      this.editing = this.regions_detailed.find(i => i.id === id);
      this.getRegionTranslations(id).then(() => {
        this.nameGe = this.region_translations.find(a => a.languageCode === "ka").title;
        this.nameEng = this.region_translations.find(a => a.languageCode === "en").title;
        this.$refs["region-modal"].show()
      });
    },

    editInstitution(id) {
      // this.editing = this.regions_detailed.find(i => i.id === id);
      this.getInstitutionTranslations(id).then((response) => {

        let ka = this.institution_translations.find(a => a.languageCode === "ka");
        this.nameGe = ka ? ka.title : "";
        this.addressGe = ka ? ka.address : "";

        let eng = this.institution_translations.find(a => a.languageCode === "en");
        this.nameEng = eng ? eng.title : "";
        this.addressEng = eng ? eng.address : "";

        this.$refs["institution-modal"].show()
      });
    },

    deleteModal(item) {
      this.$swal({
        title: "<span class=\"font-medium-1\">დარწმუნებული ხარ რომ გსურს წაშლა?</span>",
        icon: "warning",
        html:
            "<span class=\"font-small-3\">წაშლის შემდეგ ინფორმაციის აღდგენა შეუძლებელია</span>",
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "დიახ წაშალე",
        cancelButtonText: "გაუქმება",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((value) => {
        if (value.isConfirmed) {
          if (item.isRegion) {this.deleteRegion(item.id);}
          else {this.deleteInstitution(item.id);}

        }
      })
    },

    hideModal() {
      this.$refs["region-modal"].hide();
      this.$refs["institution-modal"].hide();
      this.editing = null;
      this.nameGe = "";
      this.nameEng = "";
    },

    toast(title,toaster = "b-toaster-bottom-right", append = false, variant = "success") {
      this.$bvToast.toast(`${title} წარმატებით დაემატა`, {
        title: "დაემატა",
        toaster,
        variant,
        solid: false,
        appendToast: append,
      })
    },
  }
}
</script>

<style lang="scss">

.edit-institution {
  padding: 1.4rem;

  .form-group {
    width: 45%;
  }
}

#modal-add-region {
  button.save-changes {
    width: 100%;
  }
}

#modal-add-institution {
  button.save-changes {
    width: 100%;
  }
}

.save-changes.btn span {
  font-size: 16px;
}

.edit-institution label {
  font-size: 1.057rem;
}

.modal-custom-header h4 {
  font-size: 20px;
}
</style>
